import type { AnalyticsLocation } from "@/editor/infra/analytics";

import { useLocation } from "react-router-dom";

const useCurrentAnalyticsTab = () => {
  const location = useLocation();

  let analyticsTab: AnalyticsLocation;

  if (location.pathname.includes("deep-dive")) {
    analyticsTab = "analytics_deep_dive";
  } else if (location.pathname.includes("analytics/insights")) {
    analyticsTab = "analytics_insights";
  } else if (location.pathname.includes("analytics/overview")) {
    analyticsTab = "analytics_pages";
  } else if (location.pathname.includes("analytics/home")) {
    analyticsTab = "analytics_overview";
  } else {
    analyticsTab = "analytics_overview";
  }

  return analyticsTab;
};

export default useCurrentAnalyticsTab;
